import { TOTAL_ITEMS_FOR_PAGE } from '../../utils/PaginationUtils';
import {
  CHANGED_EMPRESA_EDITING_VALUE_ACTION,
  CLEARED_EMPRESA_ACTION,
  CLEARED_EMPRESA_BY_CPF_ASSESSOR_ACTION,
  CLEARED_EMPRESAS_PAGE_ACTION,
  LOADED_ALL_EMPRESAS_ACTION,
  LOADED_EMPRESA_ACTION,
  LOADED_EMPRESA_BY_CPF_ASSESSOR_ACTION,
  LOADED_EMPRESAS_PAGE_ACTION,
  LOADING_ALL_EMPRESAS_ACTION,
  LOADED_EMPRESA_ASSESSORES,
  LOADING_EMPRESA_ACTION,
  LOADING_EMPRESA_BY_CPF_ASSESSOR_ACTION,
  LOADING_EMPRESA_BY_CNPJ,
  LOADED_EMPRESA_BY_CNPJ,
  LOADED_EMPRESA_BY_CNPJ_ASSESSORES_NECESSARIOS,
  LOADING_EMPRESA_BY_CNPJ_ASSESSORES_NECESSARIOS,
  LOADING_EMPRESA_BY_COOPERATIVA_ACTION,
  LOADED_EMPRESA_BY_COOPERATIVA_ACTION,
} from './EmpresasActions';
import { transformNullIntoEmpty } from '../../utils/DataUtils';

const EMPRESA_EDITING_NOT_NULL_PROPS = [
  'nome',
  'cnpjEmpresa',
  'cep',
  'endereco',
  'numero',
  'complemento',
  'bairro',
  'estado',
  'cidade',
];

const PAGE_LIST_INITIAL_STATE = {
  busca: '',
  page: -1,
  totalElements: 0,
  totalPages: 0,
  elements: [],
};

const EMPRESA_EDITING_INITIAL_STATE = {
  id: -1,
  nome: '',
  cnpjEmpresa: '',
  cep: '',
  endereco: '',
  numero: '',
  complemento: '',
  bairro: '',
  estado: '',
  idEstado: -1, // MOCK 23,
  cidade: '', // MOCK 'PORTO ALEGRE'
};

const INITIAL_STATE = {
  pageSize: TOTAL_ITEMS_FOR_PAGE,

  pageList: PAGE_LIST_INITIAL_STATE,

  loadingEmpresaEditing: false,
  /* object {
		id: integer,
		nome: string,
		cnpjEmpresa: string,
		cep: string,
		endereco: string,
		numero: string,
		complemento: string,
		bairro: string,
		estado: string,
		idEstado: integer,
		cidade: string,
	}*/
  empresaEditing: EMPRESA_EDITING_INITIAL_STATE,

  loadingAllList: false,
  allList: [],
  allListAssessores: [],

  loadingEmpresaByCnpj: false,
  empresaByCnpj: {},

  loadingEmpresaByCnpjAssessoresNecessarios: false,
  empresaByCnpjAssessoresNecessarios: {},

  loadingAllEmpresaByCooperativa: false,
  allEmpresaByCooperativaList: [],

  /* object {

	}*/
  loadingEmpresaByCPFAssessor: false,
  empresaByCPFAssessor: EMPRESA_EDITING_INITIAL_STATE,
};

const getRefreshedPageList = (lastPageList, newPageList) => {
  return {
    ...lastPageList,
    busca: newPageList.busca,
    page: newPageList.page,
    totalElements: newPageList.totalElements,
    totalPages: newPageList.totalPages,
    elements: [...lastPageList.elements, ...newPageList.elements],
  };
};

export default function EmpresasReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CLEARED_EMPRESA_ACTION:
      return { ...state, empresaEditing: EMPRESA_EDITING_INITIAL_STATE };
    case LOADING_EMPRESA_ACTION:
      return { ...state, loadingEmpresaEditing: action.payload };
    case LOADED_EMPRESA_ACTION:
      return {
        ...state,
        empresaEditing: transformNullIntoEmpty(
          action.payload,
          EMPRESA_EDITING_NOT_NULL_PROPS
        ),
      };
    case CHANGED_EMPRESA_EDITING_VALUE_ACTION:
      return {
        ...state,
        empresaEditing: {
          ...state.empresaEditing,
          [action.payload.name]: action.payload.value,
        },
      };
    case CLEARED_EMPRESAS_PAGE_ACTION:
      return { ...state, pageList: PAGE_LIST_INITIAL_STATE };
    case LOADED_EMPRESAS_PAGE_ACTION:
      return {
        ...state,
        pageList: getRefreshedPageList(state.pageList, action.payload),
      };
    case LOADING_ALL_EMPRESAS_ACTION:
      return { ...state, loadingAllList: action.payload };
    case LOADED_ALL_EMPRESAS_ACTION:
      return { ...state, allList: action.payload };
    case LOADED_EMPRESA_ASSESSORES:
      return { ...state, allListAssessores: action.payload };
    case CLEARED_EMPRESA_BY_CPF_ASSESSOR_ACTION:
      return { ...state, empresaByCPFAssessor: EMPRESA_EDITING_INITIAL_STATE };
    case LOADING_EMPRESA_BY_CPF_ASSESSOR_ACTION:
      return { ...state, loadingEmpresaByCPFAssessor: action.payload };
    case LOADED_EMPRESA_BY_CPF_ASSESSOR_ACTION:
      return {
        ...state,
        empresaByCPFAssessor: transformNullIntoEmpty(
          action.payload,
          EMPRESA_EDITING_NOT_NULL_PROPS
        ),
      };
    case LOADING_EMPRESA_BY_CNPJ:
      return { ...state, loadingEmpresaByCnpj: action.payload };
    case LOADED_EMPRESA_BY_CNPJ:
      return { ...state, empresaByCnpj: action.payload };
    case LOADING_EMPRESA_BY_CNPJ_ASSESSORES_NECESSARIOS:
      return {
        ...state,
        loadingEmpresaByCnpjAssessoresNecessarios: action.payload,
      };
    case LOADED_EMPRESA_BY_CNPJ_ASSESSORES_NECESSARIOS:
      return { ...state, empresaByCnpjAssessoresNecessarios: action.payload };
    case LOADING_EMPRESA_BY_COOPERATIVA_ACTION:
      return { ...state, loadingAllList: action.payload };
    case LOADED_EMPRESA_BY_COOPERATIVA_ACTION:
      return { ...state, allList: action.payload };
    default:
      return state;
  }
}
